// Merkan · Englisches Wörterbuch für Paket 1: Storno, Mahnwesen, Zahlungsbestätigung (RW-03, RW-06, RW-08)
export default {
  // Mahnung erstellen
  'per Mail': 'by email',
  'für den Druck': 'for printing',
  'Die Rechnung wird noch geladen.': 'The invoice is still loading.',
  'Für diese Rechnung oder den Kunden gilt eine Mahnsperre.': 'A dunning block applies to this invoice or the customer.',
  'Bitte eine Zahlungsfrist ab heute wählen.': 'Please choose a payment deadline from today onwards.',
  'Bitte die Mahngebühr als Betrag eintragen.': 'Please enter the reminder fee as an amount.',
  'Bitte einen Zinssatz zwischen 0 und 30 % eintragen.': 'Please enter an interest rate between 0 and 30 %.',
  'Gesendet, aber nicht protokolliert: {fehler}': 'Sent, but not recorded: {fehler}',
  '{stufe} erfasst. Das PDF steht zum Drucken bereit.': '{stufe} recorded. The PDF is ready for printing.',
  'Für Druck erfassen': 'Record for printing',
  'Rechnung nicht gefunden.': 'Invoice not found.',
  'Gemahnt werden nur gebuchte Rechnungen mit offenem Betrag.': 'Only posted invoices with an outstanding amount can be dunned.',
  'Mahnsperre: {grund}': 'Dunning block: {grund}',
  '(bis {datum})': '(until {datum})',
  'Stufe': 'Level',
  'Diese Stufe wurde bereits gesendet. Sie wird erneut versendet.': 'This level has already been sent. It will be sent again.',
  'Die vorherige Stufe fehlt noch. Bitte nur bewusst überspringen.': 'The previous level has not been sent yet. Only skip it deliberately.',
  'Zahlungsfrist': 'Payment deadline',
  'Mahngebühr in Euro': 'Reminder fee in euros',
  'Vorgabe ab Stufe {n}: {betrag}': 'Default from level {n}: {betrag}',
  'Keine Vorgabe in den Einstellungen': 'No default in the settings',
  'Verzugszinsen in % pro Jahr': 'Default interest in % per year',
  'Leer bedeutet keine Zinsen': 'Empty means no interest',
  'Mahngebühr': 'Reminder fee',
  'Verzugszinsen ({n} Tage)': 'Default interest ({n} days)',
  'Zu zahlender Betrag': 'Amount due',
  'Beim Kunden ist keine E-Mail-Adresse hinterlegt. Die Adresse kann im Mailfenster eingetragen werden.': 'No email address is stored for the customer. You can enter it in the email window.',
  '{stufe} gesendet und protokolliert.': '{stufe} sent and recorded.',
  'Weitere fällige Rechnung des Kunden aufführen ({n})': 'List the customer’s other overdue invoice ({n})',
  'Weitere fällige Rechnungen des Kunden aufführen ({n})': 'List the customer’s other overdue invoices ({n})',

  // Mahnsperre
  'Bitte einen Grund eintragen.': 'Please enter a reason.',
  'Das Enddatum liegt in der Vergangenheit.': 'The end date is in the past.',
  'Mahnsperre gesetzt.': 'Dunning block set.',
  'Mahnsperre für {name}': 'Dunning block for {name}',
  'Sperren': 'Block',
  'Solange die Sperre gilt, erscheinen die Rechnungen dieses Kunden nicht als Mahnvorschlag und können nicht gemahnt werden.': 'While the block applies, this customer’s invoices are not suggested for dunning and cannot be dunned.',
  'Solange die Sperre gilt, erscheint die Rechnung nicht als Mahnvorschlag und kann nicht gemahnt werden.': 'While the block applies, the invoice is not suggested for dunning and cannot be dunned.',
  'Grund *': 'Reason *',
  'z. B. Reklamation offen, Ratenzahlung vereinbart': 'e.g. complaint pending, instalments agreed',
  'Gilt bis': 'Valid until',
  'Leer bedeutet bis zur Aufhebung': 'Empty means until lifted',
  'Mahnsperre aufgehoben.': 'Dunning block lifted.',
  'Mahnsperre': 'Dunning block',
  'Mahnsperre setzen': 'Set dunning block',
  'Aufheben': 'Lift',
  'Gesperrt seit {datum}: {grund}': 'Blocked since {datum}: {grund}',
  'Keine Mahnsperre. Rechnungen dieses Kunden erscheinen {n} Tage nach Fälligkeit als Vorschlag.': 'No dunning block. This customer’s invoices are suggested {n} days after the due date.',
  'Keine Mahnsperre für diese Rechnung.': 'No dunning block for this invoice.',
  'Kunde gesperrt': 'Customer blocked',

  // Mahnhistorie
  'Für diese übernommene Mahnung gibt es kein Mahnblatt.': 'There is no reminder sheet for this imported reminder.',
  'Wird geladen': 'Loading',
  'Mahnhistorie': 'Dunning history',
  'Mahnen': 'Send reminder',
  'Mahnungen': 'Reminders',
  'Noch keine Mahnungen': 'No reminders yet',
  'Frist': 'Deadline',
  'inkl. Gebühr und Zinsen': 'incl. fee and interest',
  'Mahnblatt ansehen': 'View reminder sheet',

  // Einstellungen Mahnwesen und Zahlungen
  'Tage nach Fälligkeit: bitte eine ganze Zahl von 0 bis 120.': 'Days after due date: please enter a whole number from 0 to 120.',
  'Zahlungsfrist: bitte eine ganze Zahl von 1 bis 60.': 'Payment deadline: please enter a whole number from 1 to 60.',
  'Mahngebühr: bitte einen Betrag von 0 bis 1.000 Euro.': 'Reminder fee: please enter an amount from 0 to 1,000 euros.',
  'Verzugszinsen: bitte einen Satz von 0 bis 30 %.': 'Default interest: please enter a rate from 0 to 30 %.',
  'Einstellungen gespeichert.': 'Settings saved.',
  'Mahnwesen und Zahlungen': 'Dunning and payments',
  'Einstellungen für diesen Mandanten': 'Settings for this tenant',
  'Ändern nur mit dem Recht Einstellungen bearbeiten.': 'Changes require the right to edit settings.',
  'Vorschlag ab Tagen nach Fälligkeit': 'Suggest after days past due date',
  'Zahlungsfrist der Mahnung in Tagen': 'Payment deadline of the reminder in days',
  '0 bedeutet keine Gebühr': '0 means no fee',
  'Gebühr ab Stufe': 'Fee from level',
  'Leer bedeutet keine Zinsen. Unter Unternehmen gilt nach § 288 BGB der Basiszinssatz plus 9 Prozentpunkte.': 'Empty means no interest. Between businesses, Section 288 of the German Civil Code sets the base rate plus 9 percentage points.',
  'Zahlungsbestätigung bei Vollzahlung automatisch senden': 'Send payment confirmation automatically on full payment',
  'Die Bestätigung geht über das Sammelpostfach an die Rechnungsadresse des Kunden (Textbaustein zahlung_danke). Teilzahlungen lösen keine Bestätigung aus.': 'The confirmation is sent from the shared mailbox to the customer’s invoice address (text template zahlung_danke). Partial payments never trigger a confirmation.',

  // Mahnwesen Liste
  'Frist bis {datum}': 'Deadline {datum}',
  'Letzte Stufe erreicht': 'Final level reached',
  'ab {n} Tagen': 'from {n} days',
  'mindestens {n} Tage nach Fälligkeit': 'at least {n} days after due date',
  'Überfällig gesamt': 'Total overdue',
  '{n} gesperrt': '{n} blocked',
  'Zum Mahnen': 'To dun',
  'Alle überfälligen': 'All overdue',
  'Keine gesperrten Rechnungen': 'No blocked invoices',
  'Keine überfälligen Rechnungen': 'No overdue invoices',
  'Rechnungen erscheinen hier {n} Tage nach Fälligkeit.': 'Invoices appear here {n} days after the due date.',

  // Storno
  'Bitte einen Grund für das Storno eintragen.': 'Please enter a reason for the cancellation.',
  'Es wird eine Gutschrift mit negativen Mengen erzeugt, die auf {nummer} verweist, und sofort gebucht. Die Rechnung erhält den Status Storniert. Alles geschieht in einem Schritt.': 'A credit note with negative quantities referring to {nummer} is created and posted immediately. The invoice is set to Cancelled. Everything happens in one step.',
  'Bereits bezahlt': 'Already paid',
  'Mit der Gutschrift verrechnet': 'Offset against the credit note',
  'Rückzahlung an den Kunden': 'Refund to the customer',
  'Der bereits gezahlte Betrag bleibt auf der Gutschrift offen. Die Rückzahlung bitte nach Ausführung dort buchen.': 'The amount already paid remains open on the credit note. Please post the refund there once it has been made.',
  'Steht im Verlauf und am Beleg, nicht auf der Gutschrift': 'Shown in the history and on the document, not on the credit note',
  'z. B. falscher Preis, Rechnung doppelt gestellt': 'e.g. wrong price, invoice issued twice',
  'Rechnung storniert, Gutschrift {nummer} gebucht. Rückzahlung offen: {betrag}.': 'Invoice cancelled, credit note {nummer} posted. Refund outstanding: {betrag}.',
  'Rechnung storniert, Gutschrift {nummer} gebucht und verrechnet.': 'Invoice cancelled, credit note {nummer} posted and offset.',
  'Grund: {grund}': 'Reason: {grund}',

  // Zahlungen, Rückzahlung, Zahlungsbestätigung
  'Die Zahlungsbestätigung wird automatisch an den Kunden gesendet.': 'The payment confirmation will be sent to the customer automatically.',
  'Rückzahlung buchen': 'Post refund',
  'An den Kunden zurückzuzahlen: {betrag}': 'To be refunded to the customer: {betrag}',
  'Zahlungsbestätigung automatisch gesendet am {datum}.': 'Payment confirmation sent automatically on {datum}.',
  'Zahlungsbestätigung nicht gesendet: {grund}': 'Payment confirmation not sent: {grund}',
  'Von Hand senden': 'Send manually',
  'Zahlungsbestätigung wird automatisch gesendet.': 'Payment confirmation is being sent automatically.',
  'Bitte den Betrag ohne Minuszeichen eintragen.': 'Please enter the amount without a minus sign.',
  'Teilrückzahlung gebucht, offen bleiben {betrag}.': 'Partial refund posted, {betrag} remains open.',
  'Rückzahlung gebucht, {nummer} ist ausgeglichen.': 'Refund posted, {nummer} is settled.',
  'Rückzahlung zu {nummer} buchen': 'Post refund for {nummer}',
  'Rückzahlung an den Kunden. Der Betrag wird auf der Gutschrift gegengebucht.': 'Refund to the customer. The amount is posted against the credit note.',

  // Kundenportal
  'Im Kundenportal sichtbar': 'Visible in the customer portal',
  'Für den Kunden im Kundenportal sichtbar machen': 'Make visible to the customer in the customer portal',
} satisfies Record<string, string>;
